<template>
	<q-page class="q-pa-md bg-grey-2">
		<div class="row q-col-gutter-md">
			<div class="col-12">
				<q-card class="bg-primary text-white">
					<q-card-section>
						<div class="text-h4">Платежи</div>
					</q-card-section>
				</q-card>
			</div>
		</div>
		<q-card class="q-pa-md">
			<q-card-section>
				<q-table flat borderless :rows="payments" :columns="columns" row-key="id" :pagination="initialPagination"
					:loading="loading">
					<template v-slot:body-cell-status="props">
						<q-td :props="props">
							<q-chip :color="getStatusColor(props.value)" text-color="white">
								{{ getStatusVerbose(props.value) }}
							</q-chip>
						</q-td>
					</template>
					<template v-slot:body-cell-amount="props">
						<q-td :props="props">
							<q-chip color="info" text-color="white">
								{{ props.value }} руб.
							</q-chip>
						</q-td>
					</template>
					<template v-slot:body-cell-actions="props">
						<q-td :props="props">
							<q-btn flat round color="primary" icon="info" @click="showInvoiceInfo(props.row)">
								<q-tooltip>Информация о платеже</q-tooltip>
							</q-btn>
						</q-td>
					</template>
				</q-table>
			</q-card-section>

			<q-card-section actions>
				<q-btn dense flat label="Обновить статус платежей" @click="onRefreshStatus" />
			</q-card-section>
		</q-card>
		
	</q-page>


	<q-dialog v-model="infoDialog" persistent>
		<q-card style="min-width: 450px">
			<q-card-section>
				<div class="text-h6">Информация о платеже</div>
			</q-card-section>

			<q-card-section v-if="selectedInvoice">
				<q-list>
					<q-item>
						<q-item-section>
							<q-item-label overline>Идентификатор</q-item-label>
							<q-item-label>{{ selectedInvoice.id }}</q-item-label>
						</q-item-section>
					</q-item>
					<q-item>
						<q-item-section>
							<q-item-label overline>Дата</q-item-label>
							<q-item-label>{{ selectedInvoice.date }}</q-item-label>
						</q-item-section>
					</q-item>
					<q-item>
						<q-item-section>
							<q-item-label overline>Сумма</q-item-label>
							<q-item-label>{{ selectedInvoice.amount }}</q-item-label>
						</q-item-section>
					</q-item>
					<q-item>
						<q-item-section>
							<q-item-label overline>Организация</q-item-label>
							<q-item-label>{{ selectedInvoice.client.organisation.name }}</q-item-label>
							<q-item-label>ИНН {{ selectedInvoice.client.organisation.inn }}</q-item-label>
						</q-item-section>
					</q-item>
					<q-item>
						<q-item-section>
							<q-item-label overline>Описание</q-item-label>
							<q-item-label>{{ selectedInvoice.description }}</q-item-label>
						</q-item-section>
					</q-item>
					<q-item>
						<q-item-section>
							<q-item-label overline>Статус</q-item-label>
							<q-item-label>
								<q-chip :color="getStatusColor(selectedInvoice.status)" text-color="white">
									{{ getStatusVerbose(selectedInvoice.status) }}
								</q-chip>
							</q-item-label>
						</q-item-section>
						<q-item-section>
							<q-item-label overline>Изменить статус</q-item-label>
							<q-item-label>
								<q-select v-model="selectedInvoice.new_status" :options="statusOptions" />
							</q-item-label>
							<q-item-label>
								<q-btn flat dense color="primary" @click="updatePaymentStatus">Изменить</q-btn>
							</q-item-label>
						</q-item-section>
					</q-item>
				</q-list>
			</q-card-section>

			<q-card-actions align="right">
				<q-btn flat label="Закрыть" color="primary" v-close-popup />
			</q-card-actions>
		</q-card>
	</q-dialog>
</template>

<script>
import { apiUrl } from "../config";
import axios from "axios";
import { ref } from "vue";

const statusOptions = [
	{ label: 'Оплачено', value: 'paid' },
	{ label: 'Не оплачено', value: 'fail' },
]
const columns = [
	{ name: 'id', label: 'Платеж #', field: 'id', sortable: true },
	{ name: 'date', label: 'Дата', field: 'date', sortable: true },
	{ name: 'amount', label: 'Сумма', field: 'amount', sortable: true },
	{ name: 'status', label: 'Статус', field: 'status', sortable: true },
	{ name: 'description', label: 'Описание', field: 'description' },
	{ name: 'actions', label: 'Действия', field: 'actions' }
]

export default {
	name: "payments_list",
	mounted() {
		this.emitter.on('onReceivePaymentsList', (data) => {
			this.payments = data.items;
			this.loading = false;
		})
	},
	data() {
		axios
			.post(apiUrl + '/admin/payments/list/', {}, { auth: this.$store.state.credentials })
			.then((response) => {
				this.emitter.emit('onReceivePaymentsList', response.data);
			})
			.catch((error) => {
				console.log(error)
			})
		return {
			payments: ref([]),
			columns: ref(columns),
			loading: ref(true),
			infoDialog: ref(false),
			selectedInvoice: ref(null),
			initialPagination: {
				sortBy: 'date',
				descending: true,
				page: 1,
				rowsPerPage: 20
			},
			statusOptions: ref(statusOptions)
		}
	},
	methods: {
		onRefreshStatus() {
			this.loading = true;
			axios
				.post(apiUrl + '/admin/payments/list/', {}, { auth: this.$store.state.credentials })
				.then((response) => {
					this.emitter.emit('onReceivePaymentsList', response.data);
				})
				.catch((error) => {
					console.log(error)
				})
		},
		getStatusColor(status) {
			switch (status.toLowerCase()) {
				case 'send':
					return 'info'
				case 'paid':
					return 'positive'
				case 'pending':
					return 'warning'
				case 'fail':
					return 'negative'
				default:
					return 'grey'
			}
		},
		getStatusVerbose(status) {
			switch (status.toLowerCase()) {
				case 'send': return 'Списано'
				case 'paid': return 'Оплачено'
				case 'pending': return 'В ожидании'
				case 'fail': return 'Не оплачено'
				default: return 'Неизвестен'
			}
		},
		showInvoiceInfo(invoice) {
			this.selectedInvoice = invoice
			this.infoDialog = true
		},
		updatePaymentStatus() {
			axios
				.post(apiUrl + '/admin/payments/update/status/', {
					id: this.selectedInvoice.id,
                    status: this.selectedInvoice.new_status.value
				}, { auth: this.$store.state.credentials })
				.then((response) => {
					console.log(response)
					this.onRefreshStatus();
				})
				.catch((error) => {
					console.log(error)
				})
		}
	}
}
</script>

<style scoped></style>